import { UpdateTermineFormProps } from '@/domain/termine/features/UpdateTermin/shared';
import RepetitionInterval from '@/domain/termine/features/UpdateTermin/shared/components/RepetitionInterval';
import { TerminWiederholungsIntervall } from '@/domain/termine/shared/types';
import { Field } from '@e2n/ui';

export function RepetitionIntervalSelectFormField({
  className,
  form,
}: UpdateTermineFormProps) {
  return (
    <div className={`flex flex-col gap-4 w-2/3 ${className}`}>
      <form.Field name="wiederholungsIntervall">
        {(field) => (
          <Field className="flex flex-col w-full gap-1">
            <RepetitionInterval
              value={field.state.value || TerminWiederholungsIntervall.TAG}
              onChange={field.handleChange}
              form={form}
            />
          </Field>
        )}
      </form.Field>
    </div>
  );
}
